import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyEDCDashboardGraph = {
  //Study Dashboard Graph
  addNewEDCDashboardGraph,
  updateEDCDashboardGraph,
  deleteEDCDashboardGraph,
  getEDCDashboardGraph,
  getStudyDashboardDynamicGraph,

  //Study Component Graph
  updateStudyDashboardComponent,
  getStudyDashboardComponentData,
  getStudyLevelFormForDashboardStats
};

// Delete Study Dashboard Graph
async function deleteEDCDashboardGraph(studyId, id) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEDCDashboardGraph/${studyId}/${id}`,
    headersWithAuthWithoutBody("DELETE", headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Dashboard Graph
async function getEDCDashboardGraph(studyId, category, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEDCDashboardGraph/${studyId}/${category}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEDCDashboardGraph/${studyId}/${category}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add Study Dashboard Graph
async function addNewEDCDashboardGraph(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEDCDashboardGraph`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Dashboard Graph
async function updateEDCDashboardGraph(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEDCDashboardGraph`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Dashboard Standard Graph
async function getStudyDashboardDynamicGraph(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyDashboardDynamicGraph/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Update Study Dashboard Component
async function updateStudyDashboardComponent(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyDashboardComponent`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Dashboard Standard Graph
async function getStudyDashboardComponentData(studyId, category, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyDashboardComponentData/${studyId}/${category}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Dashboard Standard Graph
async function getStudyLevelFormForDashboardStats(studyId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyLevelFormForDashboardStats/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}